import React, { useCallback, useEffect, useState } from 'react';
import CustomAntModal from '../../../../components/CustomAntModal/CustomAntModal';
import { FirstSection, Footer, Table } from './AddExistingPDCMeetingStyled';
import { AiCheckBox, BasicButton } from '../../../../assets/common';
import { Pagination, Spin } from 'antd';
import { pdcMeetingApi } from '../../../../services/pdcMeetingApi';
import { useSelector } from 'react-redux';
import { get, isEmpty, xor } from 'lodash';
import { meetingApi } from '../../../../services/tcMeeting';
import DropdownWithApply from '../../../../components/DropdownWithApply/DropdownWithApply';
import { shape } from '../../../../assets/img';

const AddExistingPDCMeeting = (props) => {
  const { open, setOpen, idMeeting, fetchMobilities, fetchBuSortList } = props;
  const roleActive = useSelector((state) => state.user.roleActive);
  const [query, setQuery] = useState({
    page: 1,
    total: 0,
    search_text: '',
    business: null,
    division: null,
    opu: null,
    sector: null,
    data: [],
    selected: [],
    loading: false,
  });
  const [searchText, setSearchText] = useState('');
  const [businessDropdown, setBusinessDropdown] = useState([]);
  const [selectedBusiness, setSelectedBusiness] = useState(null);
  const [divisionDropdown, setDivisionDropdown] = useState([]);
  const [selectedDivision, setSelectedDivision] = useState(null);
  const [opuDropdown, setOPUDropdown] = useState([]);
  const [selectedOPU, setSelectedOPU] = useState(null);
  const [sectorDropdown, setSectorDropdown] = useState([]);
  const [selectedSector, setSelectedSector] = useState(null);

  function handleChangePage(page) {
    setQuery((prev) => ({ ...prev, page, selected: [] }));
  }

  const getBusinessDropdown = useCallback(() => {
    const reuslt = meetingApi.getBusinessDropdown();
    reuslt.then((res) => {
      setBusinessDropdown(get(res, 'data.result') || []);
    });
  }, []);

  const getDivisionDropdown = useCallback(() => {
    const reuslt = meetingApi.getDivisionDropdown();
    reuslt.then((res) => {
      setDivisionDropdown(get(res, 'data.result') || []);
    });
  }, []);

  const getOPUDropdown = useCallback(() => {
    const reuslt = meetingApi.getOPUDropdown();
    reuslt.then((res) => {
      setOPUDropdown(get(res, 'data.result') || []);
    });
  }, []);

  const getSectorDropdown = useCallback(() => {
    const reuslt = meetingApi.getSectorDropdown();
    reuslt.then((res) => {
      setSectorDropdown(get(res, 'data.result') || []);
    });
  }, []);

  useEffect(() => {
    getBusinessDropdown();
    getDivisionDropdown();
    getOPUDropdown();
    getSectorDropdown();
  }, []);

  useEffect(() => {
    (async function getPDCMobilityExist() {
      try {
        setQuery((prev) => ({ ...prev, loading: true }));
        const res = await pdcMeetingApi.fetchPDCMobilityExist(
          {
            page: query.page,
            search_text: query.search_text,
            business: query.business,
            division: query.division,
            opu: query.opu,
            sector: query.sector,
          },
          roleActive?.roleId,
        );
        console.log(res);
        setQuery((prev) => ({ ...prev, data: get(res, 'data.result.data') || [], total: get(res, 'data.result.total') || 0 }));
      } catch (error) {
        console.log(error);
        setQuery((prev) => ({ ...prev, data: [], total: 0, page: 1 }));
      } finally {
        setQuery((prev) => ({ ...prev, loading: false }));
      }
    })();
  }, [query.page, query.search_text, roleActive?.roleId, query.business, query.division, query.opu, query.sector]);

  async function handleAddExistingAgenda() {
    try {
      const res = await pdcMeetingApi.fetchAddMobilityFromMobilityExist({ meeting_id: idMeeting, mobility_ids: query.selected }, roleActive?.roleId);
      console.log(res);
      setOpen(null);
      fetchMobilities(1);
      fetchBuSortList && fetchBuSortList();
    } catch (error) {
      console.log(error);
    }
  }

  const handleSelectAll = () => {
    setQuery((prev) => ({
      ...prev,
      selected: xor(
        prev.selected,
        query.data.map((m) => m.mobility_id),
      ),
    }));
  };

  const handleSearch = () => {
    setQuery((prev) => ({
      ...prev,
      search_text: searchText,
      business: selectedBusiness,
      division: selectedDivision,
      opu: selectedOPU,
      sector: selectedSector,
      page: 1,
    }));
  };

  return (
    <CustomAntModal
      open={open}
      setOpen={setOpen}
      title={'Add Existing Mobility'}
      onCancel={() => setOpen(null)}
      width={1286}
      hideDefaultBtn={true}
      destroyOnClose
      closeType={1}
      styles={{
        containerPaddingTopBottom: 50,
        closePosition: [40, 56],
        headerPaddingBottom: 40,
        titleFontSize: 20,
        titleFontWeight: 700,
      }}
    >
      <Spin spinning={query.loading}>
        <FirstSection>
          <div className="custom-filter">
            <div className="filter-top">
              <input
                placeholder="Search by Position Name, Staff Name and Staff ID"
                id="search-add-mobility"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
              <DropdownWithApply
                options={businessDropdown.map((b) => b.name)}
                onApply={(selection) => {
                  setSelectedBusiness(selection);
                }}
                placeholder="Business"
                width="160px"
                height={43}
                suffixIcon={<img src={shape} alt="dropdown" />}
              />
              <DropdownWithApply
                options={divisionDropdown.map((d) => d.name)}
                onApply={(selection) => {
                  setSelectedDivision(selection);
                }}
                placeholder="Division"
                width="160px"
                height={43}
                suffixIcon={<img src={shape} alt="dropdown" />}
              />
              <DropdownWithApply
                options={sectorDropdown.map((s) => s.name)}
                onApply={(selection) => {
                  setSelectedSector(selection);
                }}
                placeholder="Sector"
                width="160px"
                height={43}
                suffixIcon={<img src={shape} alt="dropdown" />}
              />
              <DropdownWithApply
                options={opuDropdown.map((o) => o.name)}
                onApply={(selection) => {
                  setSelectedOPU(selection);
                }}
                placeholder="OPU"
                width="160px"
                height={43}
                suffixIcon={<img src={shape} alt="dropdown" />}
              />

              <BasicButton mode="teal" height="44px" width="100px" onClick={handleSearch}>
                Search
              </BasicButton>
            </div>
            <div
              className={`confirm filter-bottom ${!(query.selected.length > 0) ? 'disabled' : ''}`}
              onKeyDown={() => {}}
              onClick={handleAddExistingAgenda}
            >
              <span className="text" style={{ color: '#ffffff' }}>
                Confirm Add Existing Mobility
              </span>
            </div>
          </div>
        </FirstSection>
        <Table>
          <thead>
            <tr>
              <th scope="col">
                <div className="check-box">
                  <AiCheckBox
                    checked={query.selected.length === query.data.length && query.data.length > 0}
                    onChange={() => handleSelectAll()}
                  ></AiCheckBox>
                </div>
              </th>
              <th scope="col">HR Partner</th>
              <th scope="col">Agenda</th>
              <th scope="col">Status</th>
              <th scope="col">Meeting Name & Date</th>
            </tr>
          </thead>
          <tbody>
            {!isEmpty(query.data) &&
              query.total !== 0 &&
              query.data.map((m) => (
                <tr key={m.mobility_id}>
                  <td className="check-box">
                    <AiCheckBox
                      checked={query.selected.includes(m.mobility_id)}
                      onChange={() =>
                        setQuery((prev) => ({
                          ...prev,
                          selected: xor(prev.selected, [m.mobility_id]),
                        }))
                      }
                    ></AiCheckBox>
                  </td>
                  <td className="advocator">
                    <div className="weight-700">Advocator Name</div>
                    {!isEmpty(m.advocators) && m.advocators.map((a) => <div key={a.id}>{a.name}</div>)}
                  </td>
                  <td className="name weight-600">{m.title}</td>
                  <td className="advocator">{m.status}</td>
                  <td className="advocator">
                    <div className="weight-700">{m.meeting_name}</div>
                    <div>{m.meeting_date}</div>
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
        {!isEmpty(query.data) && query.total !== 0 && (
          <Footer>
            <Pagination
              total={query.total}
              showTotal={(total, range) => (
                <span>
                  Showing <span className="weight-700">{range[0]}</span> to <span className="weight-700">{range[1]}</span> of{' '}
                  <span className="weight-700">{total}</span> results
                </span>
              )}
              current={query.page}
              defaultPageSize={6}
              showSizeChanger={false}
              onChange={handleChangePage}
            />
          </Footer>
        )}
      </Spin>
    </CustomAntModal>
  );
};

export default AddExistingPDCMeeting;
